import type { Dictionnaire } from '../type';

export const moderation: Dictionnaire['moderation'] = {
  erreurs: {
    compteOfficiel: 'La cuenta de la aplicación no se puede denunciar. Escríbele para cualquier pregunta.',
  },
  contenu: {
    supprime: '(contenido borrado)',
    sansTexte: '(sin texto)',
  },
  merci: {
    emailParti: 'Si existe una cuenta, te acabamos de enviar un correo.',
    post: 'Gracias, nuestro equipo lo revisará. Ya no verás esta publicación.',
    signalement: 'Denuncia enviada. Gracias, lo revisaremos.',
    sortie: 'Gracias, nuestro equipo lo revisará. Ya no verás este evento.',
    simple: 'Gracias, nuestro equipo lo revisará.',
    membre: 'Gracias, nuestro equipo lo revisará. Mientras tanto, este miembro queda bloqueado.',
    support: 'Mensaje enviado. Nuestro equipo te responderá por correo.',
  },
  raisons: {
    spam: 'Spam',
    harassment: 'Acoso',
    shocking: 'Contenido impactante',
    misinformation: 'Información falsa',
    other: 'Otro',
  },
  admin: {
    durees: {
      jour: '24 horas',
      semaine: '7 días',
      mois: '30 días',
      sansTerme: 'Sin plazo',
    },
    echec: 'No se ha podido hacer.',
    fait: (geste: string) => `${geste}: hecho.`,
    gestes: {
      avertir: 'Avisar',
      liberer: 'Devolver la palabra',
      museler: 'Silenciar',
      retablir: 'Restablecer la cuenta',
      suspendre: 'Suspender la cuenta',
      suspendreQ: '¿Suspender esta cuenta?',
      retirerCoche: 'Quitar la insignia',
      poserCoche: 'Poner la insignia',
      nommerModerateur: 'Nombrar moderador',
      nommerAdmin: 'Nombrar administrador',
      retirerRole: 'Quitar el rol',
      supprimer: 'Borrar la cuenta',
      supprimerQ: '¿Borrar esta cuenta y todo lo que ha escrito? No se podrá recuperar.',
    },
    titre: 'Administración',
    chercherMembre: 'Buscar un miembro',
    sonPseudo: 'Su nombre de usuario',
    chercher: 'Buscar',
    personne: 'Nadie con ese nombre de usuario',
    autre: '← Buscar a otra persona',
    rien: 'Nada que señalar',
    avertissements: 'Avisos',
    texteMembre: 'Lo que leerá el miembro',
    pourquoi: 'Por qué (se guarda en el registro)',
    etat: {
      administrateur: 'administrador',
      moderateur: 'moderador',
      verifie: 'verificado',
      suspendu: 'suspendido',
      muetJusqua: (date: string) => `silenciado hasta el ${date}`,
      muet: 'silenciado, sin plazo',
      signalements: (n: number) => `${n} denuncias`,
      avertissements: (n: number) => `${n} avisos`,
      lu: 'leído',
      pasLu: 'sin leer',
    },
  },
  avertissement: {
    titre: 'Aviso',
    compris: 'Entendido',
  },
  file: {
    onglets: {
      ouverts: 'Por revisar',
      traites: 'Revisados',
      tout: 'Todo',
    },
    natures: {
      post: 'Publicación',
      comment: 'Comentario',
      event: 'Evento',
      user: 'Miembro',
      conversation: 'Conversación',
      help: 'Mensaje de ayuda',
    },
    masque: 'Contenido ocultado.',
    suspendu: 'Miembro suspendido.',
    classe: 'Denuncia archivada.',
    titre: 'Moderación',
    masquer: 'Ocultar el contenido',
    suspendre: 'Suspender al miembro',
    classer: 'Archivar sin más',
    rienATraiter: 'Nada por revisar',
    rienIci: 'Nada aquí',
    aucunEnAttente: 'Ninguna denuncia pendiente. Buena señal.',
    traitesIci: 'Las denuncias revisadas aparecerán aquí.',
    etatMasque: 'Contenido ocultado',
    etatSuspendu: 'Miembro suspendido',
    etatClasse: 'Archivada sin más',
    traiter: 'Revisar',
    suspendreQ: (nom: string) => `¿Suspender a ${nom}? Su acceso queda cortado hasta que se restablezca.`,
    signalements: (n: number) => `${n} denuncias`,
    signalePar: (nom: string) => `denunciado por ${nom}`,
  },
  signaler: {
    quoi: {
      post: 'esta publicación',
      comment: 'esta respuesta',
      event: 'este evento',
      member: 'este miembro',
      conversation: 'esta conversación',
    },
    impossible: 'No se puede enviar ahora mismo.',
    titre: 'Denunciar',
    indisponible: 'Este contenido ya no está disponible.',
    envoyer: 'Enviar',
    motif: '¿Por qué motivo?',
    detail: 'Añade detalles si quieres',
    detailExemple: 'Opcional: qué ha pasado y desde cuándo.',
    intro: (quoi: string) =>
      `Cuéntanos qué pasa con ${quoi}. Nuestro equipo revisa cada denuncia, y la persona afectada no recibe ningún aviso.`,
  },
};
